export default __webpack_public_path__ + "static/media/basket-blue.2823d23b.svg";